module.exports = __webpack_public_path__ + "static/quot-img-ba5a280929166321287c68ed90d5ce2b.jpg";